import { LOCATION_CHANGE } from 'connected-react-router';
import { get } from 'lodash';

// Define an event
const googlePageView = (action) => {
    const location = get(action, 'payload.location', {});

    return {
        hitType: 'pageview',
        page: `${location.pathname}${location.search}`,
    };
};


// Map the event to a Redux action
const googleEventsMap = {
    [LOCATION_CHANGE]: googlePageView,
};

export default googleEventsMap;



// WEBPACK FOOTER //
// ./src/tracking/googleEventMap.js